import { Session } from '@ais-ui/auth';
import { convertFieldsToDates, remapHeaders } from '@ais-ui/utils';
import { reorderShipDataColumns } from './orderShipDataByGridCFG';
import { ReportShipData } from './getReportResult';

export interface ShipData {
  Callsign: string;
  Country: string;
  Date: string;
  Date_sort: string;
  Destination: string;
  Distance: number;
  Draught: number | string;
  Duration: string;
  Flag: string;
  IMO: number | string;
  Length: number | string;
  MMSI: number;
  Name: string;
  'Ship type': string;
  Width: number | string;
  id: number;
}

export const getExtraJobData = async (
  session: Session,
  jobUuid: string,
  timeZone: string,
  minLat: number,
  maxLat: number,
  minLon: number,
  maxLon: number,
): Promise<ShipData[] | ReportShipData[]> => {
  // The minLat, maxLat, minLon and maxLon are used to filter the data based on the map view of the user
  const response = await session.request('getExtraJobData', {
    jobUuid: jobUuid,
    minLat: minLat,
    maxLat: maxLat,
    minLon: minLon,
    maxLon: maxLon,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  const parsedResponse =
    typeof response === 'string' ? JSON.parse(response) : response;

  let shipData: ShipData[] | ReportShipData[] = [];
  if (parsedResponse && parsedResponse.DATA) {
    shipData = parsedResponse.DATA;
    const gridConfig = parsedResponse.GRIDCFG || {};

    shipData = reorderShipDataColumns(shipData, gridConfig);

    if (shipData) {
      convertFieldsToDates(shipData, [
        'Departure',
        'departure',
        'Arrival',
        'arrival',
        'Date',
        'date',
        'DATE',
        'ata',
        'ATA',
        'atd',
        'ATD',
        'Begin',
        'begin',
        'End',
        'end',
        'Exit',
        'exit',
        'Enter',
        'enter',
        'Timestamp',
        'timestamp',
        'Dats',
        'DATS',
        'dats',
        'SDATS',
        'sdats',
        'Sdats',
        'EDATS',
        'edats',
        'Edats',
        'CPAT',
        'Cpat',
        'cpat',
        'ACTTS',
        'Actts',
        'actts',
        'DEATS',
        'Deats',
        'deats',
        'ETA',
        'Eta',
        'eta',
        'ACT',
        'Act',
        'act',
        'DEA',
        'Dea',
        'dea',
        'sta',
        'Sta',
        'STA',
        'std',
        'Std',
        'STD',
      ]);
      shipData = remapHeaders(shipData);
    }
  }

  return shipData;
};
